import React from 'react';
import { getUnitStatusConfig } from '../../../../helpers/unitStatusConfig';
import { sortUnits, formatCurrency } from '../utils/salesMapUtils';
import UnitCell from './UnitCell';

/**
 * Grid completo do mapa de vendas — renderiza blocos, andares e células.
 * Recebe gridRef para permitir captura por html2canvas.
 */
function SalesMapGrid({ gridRef, blocks, allFloors, grouped, hasBlocks }) {
    return (
        <div ref={gridRef} className="sales-map-grid-wrapper">
            {/* ── Cabeçalhos de bloco ── */}
            {hasBlocks && (
                <div className="sales-map-block-header-row">
                    <div className="floor-label-spacer" />
                    {blocks.map(block => (
                        <div key={block} className="block-header">
                            <i className="fas fa-layer-group" />
                            {block === '—' ? 'Sem Bloco' : `Bloco ${block}`}
                        </div>
                    ))}
                </div>
            )}

            {/* ── Linhas por andar ── */}
            {allFloors.map(floor => (
                <div key={floor} className="sales-map-floor-row">
                    {/* Rótulo do andar */}
                    <div className="floor-label">
                        <span>{floor === 'S/A' ? 'S/A' : `${floor}º`}</span>
                        <small>{floor === 'S/A' ? '' : 'ANDAR'}</small>
                    </div>

                    {/* Uma coluna de células por bloco */}
                    {blocks.map(block => {
                        const floorUnits = sortUnits(grouped[block]?.[floor] || []);
                        return (
                            <div key={block} className="floor-block-col">
                                {floorUnits.length === 0 ? (
                                    <div className="unit-cell unit-cell--empty" />
                                ) : (
                                    floorUnits.map(unit => {
                                        const cfg = getUnitStatusConfig(unit.status);
                                        return (
                                            <UnitCell
                                                key={unit.id}
                                                unit={unit}
                                                cfg={cfg}
                                                formatCurrency={formatCurrency}
                                            />
                                        );
                                    })
                                )}
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
}

export default SalesMapGrid;
